import axios from 'axios'

import { config } from '../../common/config'

export const getBlobPath = (
  site: string,
  section: string,
  category?: string
) => {
  const jsonFile = category ? `${category}.json` : 'index.json'
  let fullUrl = `${site}/${section}/${jsonFile}`

  if (section === 'free-items') {
    fullUrl = `defaults/${section}.json`
  }

  if (['featured-items', 'featured-authors'].includes(section)) {
    fullUrl = `${site}/${section}.json`
  }

  return fullUrl
}

// https://s3.amazonaws.com/market-shopfront-staging-api-data-us-east-1/3docean/newest-items/index.json
export const getHomepageDataFromS3 = (
  site: string,
  section: string,
  category?: string
) => {
  const path = getBlobPath(site, section, category)
  return axios.get(`${config.HOMEPAGE_JSON_BUCKET_URL}/${path}`)
}

// https://api-data.shopfront.envato.com/3docean/newest-items/index.json
export const getHomepageDataFromCloudfront = (
  site: string,
  section: string,
  category?: string
) => {
  const path = getBlobPath(site, section, category)
  return axios.get(`${config.HOMEPAGE_JSON_CDN_URL}/${path}`)
}
